"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authCertQuery = authCertQuery;
exports.authCertSubmit = authCertSubmit;

var _req = _interopRequireDefault(require("./req"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 查询授权
 * @param pram
 */
function authCertQuery(prams) {
  var data = {
    domain_name: prams.host,
    label: 22,
    version: '2.0'
  };
  return (0, _req.default)({
    url: document.location.protocol + '//authorize.crmeb.net/api/auth_cert_query',
    // url: 'https://authorize.crmeb.net/api/auth_cert_query',
    method: 'POST',
    data: data
  });
}
/**
 * 授权表单提交
 */


function authCertSubmit(data) {
  return (0, _req.default)({
    url: document.location.protocol + '//authorize.crmeb.net/api/auth_apply',
    // url: 'https://authorize.crmeb.net/api/auth_apply',
    method: 'POST',
    data: data
  });
}